export default __webpack_public_path__ + "static/media/quote.26f2dfd5.svg";